import React from "react";
import { SEO, MainLayout, TransactionDetails } from "../../../components";

const TransactionDetailsPage = () => {
  return (
    <>
      <SEO title="transactions details" />
      <MainLayout>
        <TransactionDetails />
      </MainLayout>
    </>
  );
};

export default TransactionDetailsPage;
